import { types } from 'mobx-state-tree'


const Template = types.model('Template', {
    name: types.identifier,
})

export default Template
